﻿const hiddenDivs = document.querySelectorAll('.result-listing-hidden-div') as NodeListOf<HTMLDivElement>;
const showButton = document.getElementById('show-button') as HTMLButtonElement;

function showDiv() {
    hiddenDivs.forEach((div) => {
        div.style.display = 'block';
    });
    showButton.style.display = 'none';
}

if(hiddenDivs && showButton) {
    showButton.addEventListener('click', showDiv);
}
